import React, { useState,useEffect } from "react";
import withRouter from "../../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useMutation } from "react-query";
import "../../../assets/login_page_assets/css/login.css";
import fleetFix from "../../../assets/login_page_assets/images/FleetFixLogoBlack.png";
import loginImage from "../../../assets/login_page_assets/images/login.jpg";
import { Button, Form, FormFeedback, Input, Label, Spinner } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { changePassword } from "../services/authApi";

const PasswordRecovery = (props) => {
  const { t } = useTranslation();

  document.title = `Connexion | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [error, setError] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const email = props.router.location.state?.email || "";

  useEffect(() => {
    if (!email) {
      props.router.navigate("/");  
    }
  }, [email, props.router]);
  const { isLoading, mutate } = useMutation(changePassword, {
    onSuccess: (data) => {
      toast.success("Mot de passe mis à jour avec succès");
      validation.resetForm(); 
    },
    onError: (error) => {
      toast.error(error.message);
      setError(error.message); 
    },
    onMutate: (variables) => {
      console.log("Variables transmises à la mutation:", variables); 
    }
  });
  

  const validation = useFormik({
    initialValues: {
      email: email, 
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Email est requis").email("Email invalide"),
      newPassword: Yup.string()
        .min(6, "Le mot de passe doit contenir au moins 6 caractères")
        .matches(/[A-Z]/, "Le mot de passe doit contenir au moins une majuscule")
        .matches(/[a-z]/, "Le mot de passe doit contenir au moins une minuscule")
        .matches(/\d/, "Le mot de passe doit contenir au moins un chiffre")
        .matches(/[@$!%*?&]/, "Le mot de passe doit contenir un caractère spécial")
        .required("Le mot de passe est requis"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], "Les mots de passe ne correspondent pas")
        .required("Veuillez confirmer le mot de passe"),
    }),
    onSubmit: (values) => {
      const { email, newPassword, confirmPassword } = values;
    
      // Débogage pour vérifier les valeurs
      console.log("Email:", email);
      console.log("New Password:", newPassword);
      console.log("Confirm Password:", confirmPassword);
    
      // Vérification avant l'envoi
      if (!email || !newPassword) {
        setError("Le mot de passe ou l'email sont manquants.");
        return;
      }
    
      if (newPassword !== confirmPassword) {
        setError("Les mots de passe ne correspondent pas.");
        return;
      }
    
      // Appel de mutate avec un objet contenant email et newPassword
      mutate({ email, newPassword }); // Passer un objet avec email et newPassword
    },
    
    
    
    
    
    
  });

  return (
    <div>
      <ToastContainer />
      <div className="container-login">
        <div className="login-image">
          <img src={loginImage} alt="Background" className="background-img" />
        </div>
        <div className="login-card" style={{ borderRadius: "30px", marginTop: "-50px", maxWidth: '550px', height: 'auto' }}>
          <div className="login-form" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <h3 className="h3">
              <div className="check-text-container">
                <img src={fleetFix} style={{ width: '166px', height: '28px', top: '121px', left: '667px' }} alt="Check" className="login-icon" />
                <span  style={{ fontSize: "29px",fontWeight: "700px", color: "#252525",fontFamily:'Raleway',marginTop:'50px'}}>{t("login.texte")}</span>
                <span  style={{ fontSize: "17px", fontWeight: "400px", color: "#5D5D5D", fontFamily: 'Gelix', marginTop: '30px' }}>Gardez un œil sur chaque véhicule, optimisez les itinéraires et
                </span>
                <span style={{ fontSize: "17px", fontWeight: "400px", color: "#5D5D5D", fontFamily: 'Gelix' }}>réduisez vos coûts d’exploitation.
                </span>
              </div>
            </h3>
            <div className="separator-container">
              <div className="separator-line"></div>
              <span className="separator-text" style={{ fontSize: "20px", fontWeight: "500px", color: "#252525", fontFamily: 'Raleway' }}>
                {t("lockScreen.forbiddenPassword")}
              </span>
              <div className="separator-line"></div>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <Form onSubmit={validation.handleSubmit} style={{ flex: 1 }}>
  <div className="mb-4">
 <div className="mb-3"style={{marginLeft:'20px',marginRight:'20px'}}>
                  <Input
                    style={{ color: '#8B8B8B', fontFamily: 'Lato', fontWeight: '400px', fontSize: '15px'
                      ,borderColor:'#CDCDCD',
                  borderWidth: validation.touched.email && validation.errors.email ? '1px' : '1px',
                     }}
                    name="email"
                    id="email"
                    className="form-control pe-5"
                    value={email} 
                    disabled
                  />
                </div>
  </div>

  <div className="mb-3" style={{ marginTop: '25px' ,marginLeft:'20px',marginRight:'20px'}}>
  <div className="position-relative auth-pass-inputgroup mb-3">
  <Input
    style={{
      color: '#8B8B8B',
      fontFamily: 'Lato',
      fontWeight: '400px',
      fontSize: '15px',
      borderColor: '#CDCDCD',
      borderWidth: validation.touched.newPassword && validation.errors.newPassword ? '1px' : '1px',
  
    }}
    name="newPassword"
    id="newPassword-input"
    value={validation.values.newPassword}
    type={passwordShow ? "text" : "password"}
    className="form-control pe-5"
    placeholder={t("login.newPasswordPlaceholder")}
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    invalid={!!(validation.touched.newPassword && validation.errors.newPassword)}
    aria-label="Nouveau mot de passe"
  />
  <button
    className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none text-muted"
    type="button"
    onClick={() => setPasswordShow(!passwordShow)}
    style={{
      background: "transparent",
      border: "none",
      right: "10px",

    }}
  >
    <i className="ri-eye-fill align-middle fs-15"></i>
  </button>
</div>

  </div>
  

  <div className="mb-3" style={{ marginTop: '25px' ,marginLeft:'20px',marginRight:'20px'}}>
  <div className="position-relative auth-pass-inputgroup mb-3">
  <Input
    style={{
      color: '#8B8B8B',
      fontFamily: 'Lato',
      fontWeight: '400px',
      fontSize: '15px',
      borderColor: '#CDCDCD',
      borderWidth: validation.touched.confirmPassword && validation.errors.confirmPassword ? '1px' : '1px',
    }}
    name="confirmPassword"
    id="confirmPassword-input"
    value={validation.values.confirmPassword}
    type={confirmPasswordShow ? "text" : "password"}
    className="form-control pe-5"
    placeholder={t("login.confirmNewPasswordPlaceholder")}
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    invalid={!!(validation.touched.confirmPassword && validation.errors.confirmPassword)}
    onPaste={(e) => e.preventDefault()} // Empêche le collage
    aria-label="Confirmer le mot de passe"
  />
  {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
    <FormFeedback
      type="invalid"
      style={{
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
      }}
    >
      {validation.errors.confirmPassword}
    </FormFeedback>
  ) : null}
  <button
    className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none text-muted"
    type="button"
    onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
    style={{
      background: "transparent",
      border: "none",
      right: "10px",
 
    
    }}
  >
    <i className="ri-eye-fill align-middle fs-15"></i>
  </button>
</div>



  </div>

  <div className="mb-3"style={{marginLeft:'20px',marginRight:'20px'}}>
    <Button
      type="submit"
      className="form-control btn btn-soft-success pe-5 login-fc"
      block
      style={{ backgroundColor: "#000000", color: "white", fontFamily:'Gelix',fontWeight:'500px',fontSize:'17px'}}
              disabled={!(validation.isValid && validation.dirty)}
    >
      {isLoading ? <Spinner size="sm" /> : t("login.changePasswordButton")}
    </Button>
  </div>
  <div style={{ textAlign: 'center', marginBottom: '20px', marginTop: '20px' }}>
                <span style={{ fontSize: "15px", fontWeight: "400px", color: "#252525", fontFamily: 'Gelix' }}>
                  {t("login.compte")}
                </span>
                <a href="/login"
                  style={{ fontSize: "15px", fontWeight: "500px", color: "#E97D00", textDecoration: "underline", fontFamily: 'Gelix' }}
                >
                  {t("login.connected")}
                </a>
              </div>
</Form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(PasswordRecovery);
